import { axios } from "@/plugins/axios";

function spontanZahlungCheck(amount) {
    var payload = "";
    if (amount !== undefined) {
        payload = "betrag=" + amount;
    }
    return axios.post(
        "?Mode=MeinServicebereich&Function=SpontanZahlungCheck",
        payload
    );
}

function spontanZahlung(amount) {
    var payload = "";
    if (amount !== undefined) {
        payload = "betrag=" + amount + "&confirmation=true";
    }
    return axios.post(
        "?Mode=MeinServicebereich&Function=SpontanZahlung",
        payload
    );
}

export { spontanZahlungCheck, spontanZahlung };
